import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ActividadCreadaType {
	actividadIndividualKey: string;
	actividadGrupalKey: string;
	sesionKey: string;
	isIndividualVisible: null | boolean;
	isGrupalVisible: null | boolean;
}
const initialState: ActividadCreadaType = {
	actividadIndividualKey: '',
	actividadGrupalKey: '',
	sesionKey: '',
	isIndividualVisible: null,
	isGrupalVisible: null
};

const actividadCreadaStateSlice = createSlice({
	name: 'actividadCreadaState',
	initialState,
	reducers: {
		setActividadCreadaState: (state, action: PayloadAction<ActividadCreadaType>) => {
			const actividadCreadaState = action.payload;
			return { ...state, actividadCreadaState };
		},
		resetActividadCreadaState: () => initialState
	}
});

export const { setActividadCreadaState, resetActividadCreadaState } = actividadCreadaStateSlice.actions;

export default actividadCreadaStateSlice.reducer;
